export default {
  // Common
  common: {
    app_code: 'dmp',
    collectedEvents: 'อีเวนต์ที่รวบรวม',
    resetView: 'รีเซ็ตการแสดงผล',
    app_name: 'การท่องเที่ยว DX ฮิกาชิคาวะ',
    env_prod: '',
    env_prod_mobile: '',
    env_test: '【สภาพแวดล้อมทดสอบ】',
    env_local: '【สภาพแวดล้อมโลคัล】',
    env_test_mobile: '[ทดสอบ]',
    env_local_mobile: '[ท้องถิ่น]',
    loading: 'กำลังประมวลผล...',
    logout: 'ออกจากระบบ',
    admin: 'ผู้ดูแลระบบ',
    users: 'ผู้ใช้งาน',
    userRegistrationRequests: 'คำขอลงทะเบียนผู้ใช้งาน',
    dataProviders: 'ผู้ให้บริการข้อมูล',
    masterData: 'ข้อมูลหลัก',
    postalCodes: 'ฐานข้อมูลรหัสไปรษณีย์',
    systemLogs: 'บันทึกระบบ',
    language: 'การตั้งค่าภาษา',
    changeLanguage: 'เปลี่ยนภาษา',
    copyright: 'Copyright (C) Higashikawa Tourism DX Consortium',
    errorGeneral: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
    notSet: 'ไม่ได้ตั้งค่า',
    contact: 'ติดต่อเรา',
    calendar: {
      weekdays: {
        sun: 'อา',
        mon: 'จ',
        tue: 'อ',
        wed: 'พ',
        thu: 'พฤ',
        fri: 'ศ',
        sat: 'ส',
      },
    },
    error_dialog: {
      default_title: 'ข้อผิดพลาด',
      ok: 'ตกลง'
    },
    info_dialog: {
      default_title: 'ข้อมูล',
      ok: 'ตกลง'
    },
    warning_dialog: {
      default_title: 'คำเตือน',
      ok: 'ตกลง'
    },
    confirm_dialog: {
      default_title: 'ยืนยัน',
      ok: 'ตกลง',
      cancel: 'ยกเลิก'
    },
  },

  // Header
  header: {
    welcomeMessage: 'สวัสดี ',
    nameTitle: ' คุณ'
  },

  // Side Menu
  sideMenues: {
    home: 'หน้าหลัก',
    events: 'กิจกรรม',
    accommodationBookings: 'ที่พัก',
    import: 'นำเข้า',
    export: 'ส่งออก',
    masterData: 'ข้อมูลหลัก',
    dataManagement: 'การจัดการข้อมูล',
    donatorInformation: 'ข้อมูลผู้บริจาค',
    statisticData: 'สถิติ',
    eventOrganizers: 'ผู้จัดงาน',
  },

  // Pagination
  pagination: {
    itemsPerPage: 'จำนวนรายการที่แสดงต่อหน้า',
    itemsCount: '{count}',
    showing: 'แสดง {from} - {to} จากทั้งหมด {total} รายการ',
    page: 'หน้า',
    totalPages: '/ {total}',
    no_records: 'ไม่พบข้อมูลที่ตรงกัน',
    per_page: {
      '25': 'แสดง 25 รายการ',
      '50': 'แสดง 50 รายการ',
      '100': 'แสดง 100 รายการ'
    }
  },

  // HTTP status error messages
  httpStatusMessages: {
    httpStatusTitle403: 'ไม่มีสิทธิ์เข้าถึง',
    httpStatusMsg403: 'คุณไม่มีสิทธิ์ในการดูหน้านี้\nคุณไม่มีสิทธิ์ที่จำเป็นหรือการเข้าถึงถูกจำกัด',
    httpStatusTitle404: 'ไม่พบหน้า',
    httpStatusMsg404: 'หน้าไม่มีอยู่หรือ URL ไม่ถูกต้อง',
    httpStatusTitle500: 'ข้อผิดพลาดเซิร์ฟเวอร์',
    httpStatusMsg500: 'เกิดข้อผิดพลาดของเซิร์ฟเวอร์\nกรุณารอสักครู่แล้วลองเข้าถึงอีกครั้ง'
  },

  // Validation messages
  validation: {
    required: {
      currentPassword: 'กรุณากรอกรหัสผ่านปัจจุบัน',
      newPassword: 'กรุณากรอกรหัสผ่านใหม่',
      confirmPassword: 'กรุณากรอกรหัสผ่านใหม่（ยืนยัน）'
    },
    minLength: 'รหัสผ่านใหม่ต้องมีอย่างน้อย 8 ตัวอักษร',
    mismatch: 'รหัสผ่านใหม่และรหัสผ่านยืนยันไม่ตรงกัน',
    error: 'ไม่สามารถเปลี่ยนรหัสผ่านได้',
    password: {
      minLength: 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร',
      invalidCharacters: 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร และรวมตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และสัญลักษณ์ (! . - _)',
      sameAsCurrentPassword: 'ไม่สามารถใช้รหัสผ่านเดียวกันกับรหัสผ่านปัจจุบันได้'
    }
  },

  // Password change related
  password: {
    change: 'เปลี่ยนรหัสผ่าน',
    current: 'รหัสผ่านปัจจุบัน',
    new: 'รหัสผ่านใหม่',
    confirm: 'รหัสผ่านใหม่（ยืนยัน）',
    button: 'เปลี่ยนรหัสผ่าน',
    cancel: 'ยกเลิก',
    minLength: 'กรุณากรอกอย่างน้อย 8 ตัวอักษร',
    success: 'เปลี่ยนรหัสผ่านสำเร็จแล้ว',
    failed: 'ไม่สามารถเปลี่ยนรหัสผ่านได้'
  },

  // Email change
  email: {
    change: 'เปลี่ยนอีเมล',
    current: 'อีเมลปัจจุบัน',
    new: 'อีเมลใหม่',
    button: 'เปลี่ยนอีเมล',
    cancel: 'ยกเลิก',
    success: 'ส่งคำขอเปลี่ยนอีเมลแล้ว อีเมลยืนยันได้ถูกส่งไปยังอีเมลใหม่แล้ว',
    failed: 'ไม่สามารถเปลี่ยนอีเมลได้',
    confirmSuccess: 'เปลี่ยนอีเมลสำเร็จแล้ว',
    confirmFailed: 'ไม่สามารถยืนยันการเปลี่ยนอีเมลได้',
    complete: {
      title: 'เปลี่ยนอีเมลสำเร็จแล้ว',
      message: 'การเปลี่ยนอีเมลเสร็จสมบูรณ์แล้ว กรุณาเข้าสู่ระบบด้วยอีเมลใหม่ของคุณ',
      loginButton: 'ไปยังหน้าเข้าสู่ระบบ',
      processing: 'กำลังดำเนินการ...',
      errorTitle: 'เกิดข้อผิดพลาด',
      invalidToken: 'โทเค็นไม่ถูกต้อง',
      tokenNotFound: 'ไม่พบโทเค็น',
      tokenExpired: 'โทเค็นหมดอายุแล้ว',
      failed: 'ไม่สามารถเปลี่ยนอีเมลได้'
    },
    validation: {
      currentEmailRequired: 'กรุณากรอกอีเมลปัจจุบัน',
      currentEmailInvalid: 'รูปแบบอีเมลปัจจุบันไม่ถูกต้อง',
      newEmailRequired: 'กรุณากรอกอีเมลใหม่',
      newEmailInvalid: 'รูปแบบอีเมลใหม่ไม่ถูกต้อง',
      sameEmail: 'ไม่สามารถใช้อีเมลเดียวกับอีเมลปัจจุบันได้'
    }
  },

  // Legal pages
  legal: {
    titleTermsOfUse: 'เงื่อนไขการใช้งาน',
    titlePrivacyPolicy: 'นโยบายการคุ้มครองข้อมูลส่วนบุคคล',
    titleExternalTools: 'รายการเปิดเผยเกี่ยวกับเครื่องมือส่งข้อมูลภายนอก',
  },

  // Authentication pages
  auth: {
    // Login page
    login: {
      title: 'เข้าสู่ระบบ',
      subtitle: 'หน้าจอผู้ใช้',
      subtitle_admin: 'พอร์ทัลการจัดการระบบ',
      email: 'ที่อยู่อีเมล',
      password: 'รหัสผ่าน',
      remember: 'รักษาสถานะเข้าสู่ระบบ',
      submit: 'เข้าสู่ระบบ',
      signupLink: 'สมัครใช้งานใหม่',
      forgotPasswordLink: 'ลืมรหัสผ่านคลิกที่นี่',
      forNewUserTitle: 'สำหรับผู้ใช้งานครั้งแรก',
      forNewUserDescription: 'การใช้บริการท่องเที่ยว DX ฮิกาชิคาวะ จำเป็นต้องสมัครลงทะเบียน หลังจากได้รับการอนุมัติคุณจะสามารถเข้าสู่ระบบได้',
      validation: {
        emailRequired: 'กรุณากรอกที่อยู่อีเมล',
        emailInvalid: 'กรุณากรอกที่อยู่อีเมลในรูปแบบที่ถูกต้อง',
        passwordRequired: 'กรุณากรอกรหัสผ่าน'
      },
      error: {
        invalid_credentials: 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
        failed: 'การเข้าสู่ระบบล้มเหลว'
      }
    },

    // Admin Login page
    adminLogin: {
      title: 'เว็บผู้ดูแล DMP',
      email: 'ที่อยู่อีเมล',
      password: 'รหัสผ่าน',
      remember: 'คงสถานะการเข้าสู่ระบบ',
      submit: 'เข้าสู่ระบบ',
      authOidc: 'การยืนยันตัวตน Microsoft Entra ID',
      emailLoginNotice: 'เข้าสู่ระบบด้วยอีเมล',
      forgotPasswordLink: 'ลืมรหัสผ่าน?',
      error: {
        failed: 'การเข้าสู่ระบบ Microsoft Entra ID ล้มเหลว'
      }
    },

    activate_success: 'การลงทะเบียนบัญชีเสร็จสมบูรณ์แล้ว',
    logout_success: 'ออกจากระบบแล้ว',

    // Signup page
    signup: {
      title: 'การลงทะเบียนใช้งานผู้ใช้',
      description: 'การใช้บริการ "Higashikawa Tourism DX" จำเป็นต้องขอสมัครสมาชิก หลังจากการอนุมัติเสร็จสิ้น คุณจะสามารถเข้าสู่ระบบได้',
      name: 'ชื่อผู้ใช้',
      email: 'ที่อยู่อีเมล',
      officeName: 'ชื่อสถานที่',
      postalCode: 'รหัสไปรษณีย์',
      address: 'ที่อยู่',
      phoneNumber: 'หมายเลขโทรศัพท์',
      organization: 'องค์กร',
      selectOrganization: 'กรุณาเลือกองค์กร',
      organizations: {
        noOrganization: 'ไม่มีองค์กร',
        tourAssociate: 'สมาคมการท่องเที่ยวฮิงาชิคาวะ',
        chamberCommerce: 'หอการค้าฮิงาชิคาวะ'
      },
      submit: 'ยืนยันข้อมูล',
      confirmTitle: 'ยืนยันข้อมูลที่กรอก',
      confirmDescription: 'กรุณาตรวจสอบข้อมูลด้านล่าง หากถูกต้องแล้ว กรุณาคลิกปุ่ม "ส่งใบสมัคร"',
      register: 'ส่งใบสมัคร',
      back: 'กลับ',
      loginLink: 'เข้าสู่ระบบที่นี่',
      successTitle: 'รับใบสมัครแล้ว',
      successMessage: 'รับใบสมัครแล้ว หลังจากการอนุมัติเสร็จสิ้น คุณจะได้รับอีเมลที่มีคำแนะนำสำหรับการลงทะเบียน',
      backToLogin: 'กลับไปหน้าจอเข้าสู่ระบบ',
      validation: {
        nameRequired: 'กรุณากรอกชื่อผู้ใช้',
        nameMaxLength: 'ชื่อผู้ใช้ต้องมีความยาวไม่เกิน 255 ตัวอักษร',
        emailRequired: 'กรุณากรอกที่อยู่อีเมล',
        emailInvalid: 'กรุณากรอกที่อยู่อีเมลในรูปแบบที่ถูกต้อง',
        emailMaxLength: 'ที่อยู่อีเมลต้องมีความยาวไม่เกิน 255 ตัวอักษร',
        officeNameRequired: 'กรุณากรอกชื่อสถานที่',
        officeNameMaxLength: 'ชื่อสถานที่ต้องมีความยาวไม่เกิน 255 ตัวอักษร',
        postalCodeRequired: 'กรุณากรอกรหัสไปรษณีย์',
        postalCodeInvalid: 'กรุณากรอกรหัสไปรษณีย์ในรูปแบบ "999-9999"',
        addressRequired: 'กรุณากรอกที่อยู่',
        addressMaxLength: 'ที่อยู่ต้องมีความยาวไม่เกิน 255 ตัวอักษร',
        phoneNumberRequired: 'กรุณากรอกหมายเลขโทรศัพท์',
        phoneNumberInvalid: 'หมายเลขโทรศัพท์สามารถกรอกได้เฉพาะเครื่องหมาย “+” (ตัวอักษรครึ่งมุม) และตัวเลขครึ่งมุมเท่านั้น โดยสามารถกรอกได้สูงสุด 15 หลัก',
        organizationRequired: 'กรุณาเลือกองค์กร'
      },
      agreePrefix: 'ฉันยอมรับ',
      agreeConjunction: ' และ ',
      agreeSuffix: ''
    },

    // Activate page
    activate: {
      title: 'ลงทะเบียนหลักผู้ใช้',
      description: 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร และรวมตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และสัญลักษณ์ (! . - _)',
      password: 'รหัสผ่าน',
      passwordConfirm: 'รหัสผ่าน（ยืนยัน）',
      submit: 'ลงทะเบียน',
      loading: 'กำลังโหลดข้อมูลผู้ใช้...',
      successTitle: 'ลงทะเบียนหลักเสร็จสิ้น',
      successMessage: 'การลงทะเบียนผู้ใช้เสร็จสิ้นแล้ว',
      goHome: 'ไปยังหน้าหลัก',
      errorTitle: 'เกิดข้อผิดพลาด',
      backToLogin: 'กลับไปหน้าจอเข้าสู่ระบบ',
      invalidToken: 'ลิงก์ไม่ถูกต้อง ไม่พบโทเคนการยืนยันตัวตน',
      tokenExpired: 'โทเคนไม่ถูกต้องหรือถูกใช้ไปแล้ว',
      userNotFound: 'ไม่สามารถดึงข้อมูลผู้ใช้ได้',
      activationFailed: 'การลงทะเบียนหลักล้มเหลว',
      validation: {
        passwordRequired: 'กรุณากรอกรหัสผ่าน',
        passwordMinLength: 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร',
        passwordConfirmRequired: 'กรุณากรอกการยืนยันรหัสผ่าน',
        passwordMismatch: 'รหัสผ่านไม่ตรงกัน'
      }
    },

    // Forgot password page
    forgotPassword: {
      title: 'รีเซ็ตรหัสผ่าน',
      description1: 'กรุณากรอกที่อยู่อีเมลที่ลงทะเบียนไว้',
      description2: 'เราจะส่งอีเมลสำหรับรีเซ็ตรหัสผ่านให้คุณ',
      email: 'ที่อยู่อีเมล',
      submit: 'ส่งอีเมลยืนยัน',
      backToLogin: 'กลับ',
      success: 'ได้ส่งอีเมลสำหรับตั้งรหัสผ่านใหม่แล้ว กรุณาตรวจสอบอีเมลของคุณ',
      failed: 'การส่งอีเมลล้มเหลว กรุณารอสักครู่แล้วลองใหม่อีกครั้ง',
      confirmTitle: 'กรุณาตรวจสอบอีเมลของคุณ',
      confirmDescription1: 'ส่งอีเมลไปที่ ',
      confirmDescription2: 'กรุณารีเซ็ตรหัสผ่านจาก URL ที่ระบุในอีเมล',
      validation: {
        emailRequired: 'กรุณากรอกที่อยู่อีเมล',
        emailInvalid: 'กรุณากรอกที่อยู่อีเมลที่ถูกต้อง'
      }
    },

    // Reset password page
    resetPassword: {
      title: 'รีเซ็ตรหัสผ่าน',
      description1: 'กรุณากรอกรหัสผ่านใหม่',
      description2: '* รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร และรวมตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และสัญลักษณ์ (! . - _)',
      email: 'ที่อยู่อีเมล',
      password: 'รหัสผ่านใหม่',
      passwordConfirm: 'ยืนยันรหัสผ่านใหม่',
      submit: 'รีเซ็ตรหัสผ่าน',
      backToLogin: 'กลับไปหน้าเข้าสู่ระบบ',
      success: 'รีเซ็ตรหัสผ่านสำเร็จแล้ว',
      failed: 'การรีเซ็ตรหัสผ่านล้มเหลว',
      validation: {
        emailRequired: 'กรุณากรอกที่อยู่อีเมล',
        emailInvalid: 'กรุณากรอกที่อยู่อีเมลที่ถูกต้อง',
        passwordRequired: 'กรุณากรอกรหัสผ่าน',
        passwordMinLength: 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร',
        passwordConfirmRequired: 'กรุณายืนยันรหัสผ่าน',
        passwordMismatch: 'รหัสผ่านไม่ตรงกัน',
        sameAsCurrentPassword: 'ไม่สามารถใช้รหัสผ่านเดียวกันกับรหัสผ่านปัจจุบันได้'
      }
    }
  },

  // Data Providers (Laravel translation structure)
  // API Call Histories
  api_call_histories: {
    title: 'สถานะการเรียก API สาธารณะ',
    note: '* รวมจำนวนการเรียกและรหัสสถานะแยกตามระบบต้นทาง ไม่แสดงเนื้อหาคำขอและการตอบกลับ',
    days: '{days} วันล่าสุด',
    data_provider: 'ระบบต้นทาง',
    endpoint: 'Endpoint',
    method: 'เมธอด',
    status_code: 'สถานะ',
    calls: 'จำนวนการเรียก',
    first_called_at: 'การเรียกครั้งแรก',
    last_called_at: 'การเรียกครั้งล่าสุด',
    empty: 'ไม่มีบันทึกการเรียกในช่วงเวลานี้',
    failures_title: 'รายละเอียดการเรียกที่ล้มเหลว',
    failures_note: '* แสดงเฉพาะชื่อฟิลด์ที่ถูกปฏิเสธ ไม่แสดงค่าที่ส่งมา',
    message: 'ข้อความ',
    rejected_fields: 'ฟิลด์ที่ถูกปฏิเสธ',
    value_types_title: 'ชนิดของค่าที่ถูกปฏิเสธ',
    value_types_note: '* รวมจากการล้มเหลว 5 ครั้งล่าสุด อ่านเฉพาะชนิดของค่าที่ถูกปฏิเสธ ไม่อ่านค่าจริง',
    value_type: 'ชนิด',
    occurrences: 'จำนวนครั้ง',
  },

  data_providers: {
    title: 'ผู้ให้บริการข้อมูล',
    name: 'ชื่อ',
    status: 'สถานะ',
    description: 'คำอธิบาย',
    register: 'ลงทะเบียน',
    edit: 'แก้ไข',
    delete: 'ลบ',
    details: 'รายละเอียด',

    // Status
    status_values: {
      active: 'ใช้งาน',
      inactive: 'ไม่ใช้งาน'
    },

    // Form
    form: {
      title: 'ลงทะเบียนผู้ให้บริการข้อมูล',
      edit_title: 'แก้ไขผู้ให้บริการข้อมูล',
      name_label: 'ชื่อ',
      status_label: 'สถานะ',
      status_placeholder: 'กรุณาเลือกสถานะ',
      description_label: 'คำอธิบาย',
      register_button: 'ลงทะเบียน',
      update_button: 'อัปเดต',
      cancel: 'ยกเลิก',
      create_note: 'การจัดการโทเคนจะพร้อมใช้งานในหน้าจอรายละเอียดหลังจากสร้างแล้ว'
    },

    // Messages
    messages: {
      created: 'ลงทะเบียนผู้ให้บริการข้อมูล「{name}」แล้ว',
      updated: 'อัปเดตผู้ให้บริการข้อมูล「{name}」แล้ว',
      deleted: 'ลบผู้ให้บริการข้อมูล「{name}」แล้ว',
      confirm_delete: 'คุณแน่ใจหรือไม่ว่าต้องการลบ?'
    }
  },

  // Token Management
  tokens: {
    title: 'การจัดการโทเคน',
    generate_token: 'สร้างโทเคน',
    personal_access_tokens: 'โทเคนการเข้าถึงส่วนบุคคล',
    name: 'ชื่อ',
    token_value: 'ค่าโทเคน',
    abilities: 'สิทธิ์',
    expires_at: 'วันหมดอายุ',
    created_at: 'วันเวลาที่สร้าง',
    actions: 'การดำเนินการ',
    delete: 'ลบ',
    copy_token: 'คัดลอกโทเคน',
    token_not_shown_after_creation: '（โทเคนจะไม่แสดงหลังจากการสร้าง）',
    never_expires: 'ไม่มีกำหนด',
    no_tokens: 'ไม่พบโทเคน',

    // Messages
    messages: {
      token_generated: 'สร้างโทเคนสำเร็จแล้ว',
      token_deleted: 'ลบโทเคนสำเร็จแล้ว',
      token_copied: 'คัดลอกโทเคนไปยังคลิปบอร์ดแล้ว',
      copy_failed: 'คัดลอกโทเคนไม่สำเร็จ',
      confirm_delete_token: 'คุณแน่ใจว่าต้องการลบโทเคนนี้หรือไม่?',
      enter_token_name: 'กรุณาใส่ชื่อโทเคน：',
      max_tokens_reached: 'สามารถสร้างโทเคนได้สูงสุด 10 รายการต่อผู้ให้บริการข้อมูล'
    }
  },

  // Dashboard related
  dashboard: {
    title: 'แดชบอร์ด',
    subtitle: 'ติดตามรายวันการจองที่พัก การจองกิจกรรม แนวโน้มผู้มาเยือน และอื่นๆ',
    tooltip: '選択中期間の宿泊予約またはイベント予約をしている訪問者数を集計',

    // Time periods
    periods: {
      yesterday: 'วันก่อนหน้า',
      today: 'วันนี้',
      tomorrow: 'วันถัดไป'
    },

    // Statistics labels
    stats: {
      hotelBookings: 'จำนวนการจองที่พัก',
      eventBookings: 'จำนวนการจองกิจกรรม',
      eventsCount: 'จำนวนกิจกรรม',
      hotelBookingsDesc: 'จำนวนการจอง ไม่ใช่จำนวนผู้พักที่คาดว่าจะเข้าพัก',
      eventBookingsDesc: 'จำนวนการจอง ไม่ใช่จำนวนผู้จองกิจกรรม',
      eventsCountDesc: 'เมื่อวานเป็นจำนวนจริง วันนี้หรือพรุ่งนี้เป็นจำนวนที่คาดไว้'
    },

    // Chart
    chart: {
      title: 'แนวโน้มผู้มาเยือน',
      subtitle: 'กำหนดการและผลจริง',
      thisYearVisitors: ' ปี',
      lastYearVisitors: ' ปี',
      period: {
        oneWeek: '1 สัปดาห์',
        oneMonth: '1 เดือน',
        threeMonths: '3 เดือน'
      }
    },

    // Summary stats
    summary: {
      totalHotelBookings: 'รวมจำนวนการจองที่พัก',
      totalEventBookings: 'รวมจำนวนการจองกิจกรรม',
      totalEvents: 'รวมจำนวนกิจกรรม',
      avgDailyVisitors: 'จำนวนผู้มาเยือนเฉลี่ยรายวัน',
      periods: {
        threeDayTotal: 'จำนวนที่กำหนดไว้ 3 วันล่าสุดรวมวันนี้',
        thirtyDayAverage: 'ค่าเฉลี่ย 30 วันที่ผ่านมา'
      }
    },

    // Home page
    home: {
      title: 'หน้าหลัก',
    },

    // Visitor Card
    visitor: {
      title: 'จำนวนผู้มาเยือน',
      person_unit: 'คน',
      year_label: 'ปี {year}',
      selected_period_label: 'ช่วงเวลาที่เลือก',
      previous_year_same_period_label: 'ช่วงเดียวกันของปีก่อนหน้า',
    },

    // Daily Visitor Card
    daily_visitor: {
      residential_area: 'พื้นที่ที่อยู่อาศัย',
      visitor: 'ผู้มาเยือน',
      others: 'อื่นๆ',
      unanswered: 'ไม่ระบุ',
      no_data: 'ไม่มีข้อมูล',
    },

    // Date Range Picker
    date_range: {
      cancel: 'ยกเลิก',
      apply: 'ใช้',
      alert: {
        max_range: 'คุณสามารถเลือกช่วงวันที่ได้สูงสุด {days} วัน',
        select_dates: 'โปรดเลือกทั้งวันที่เริ่มต้นและวันที่สิ้นสุด',
      },
    },

    // Repeat Visitors & Higashikawa Shareholder
    stats: {
      title_repeat_visitors: 'ผู้มาเยือนซ้ำ',
      title_higashikawa_stockholder_visitors: 'ผู้ถือหุ้นฮิกาชิคาวะ',
      number_unit: '%',
      trend_up: '↑',
      trend_down: '↓',
      trend_na: '± N/A (ไม่มีข้อมูลปีก่อน)',
    },

    // Demographics
    demographics: {
      title_age_group: 'กลุ่มอายุ',
      title_gender: 'เพศ',
      age_group_less_20: '20 <',
      age_group_20: '20 < 30',
      age_group_30: '30 < 40',
      age_group_40: '40 < 50',
      age_group_50: '50 < 60',
      age_group_more_60: '60 <',
      age_group_unknown: 'อื่นๆ',
      gender_male: 'ชาย',
      gender_female: 'หญิง',
      gender_unknown: 'ไม่ตอบ',
    },

    // Occupancy Card
    occupancy: {
      title: 'อัตราการใช้ที่พัก',
      subtitle: 'จำนวนการจองผ่าน tomarin',
      detail_link: 'รายละเอียดการจองที่พัก',
      occupancy_rate: 'อัตราการใช้',
      total_rooms: 'จำนวนห้องทั้งหมด',
      booked_rooms: 'จำนวนห้องที่จองแล้ว',
      rooms_unit: ' ห้อง',
      additional_note: '* แสดงอัตราส่วนของห้องที่จองผ่าน tomarin ต่อจำนวนห้องทั้งหมด × จำนวนวันในช่วงเวลาที่เลือก',
      booked_rooms_label: 'จองแล้ว',
      available_rooms_label: 'ว่าง',
    },

    // Crowd Level Calendar Card
    crowdLevelCalendar: {
      title: 'สถานะการจัดกิจกรรม',
      legend: {
        crowded: '100 คน〜',
        crowdedBit: '50〜99 คน',
        crowdedModerate: '1〜49 คน',
        crowdedNone: '0 คน',
      },
      modal: {
        title: 'รายละเอียดกิจกรรม',
        date: 'วันที่',
        totalEvents: 'จำนวนกิจกรรม',
        eventCapacities: 'ความจุกิจกรรม',
        eventParticipants: 'ผู้เข้าร่วมกิจกรรม',
        forecastedEventParticipants: 'ผู้เข้าร่วมกิจกรรมที่คาดการณ์',
        unit: ' รายการ',
        peopleUnit: ' คน',
      },
    },

    // Events Combined Card
    events: {
      reservation_title: 'จำนวนการจองกิจกรรม',
      reservation_subtitle: 'กิจกรรมที่จัดขึ้นและจำนวนการจอง',
      event_reservation_label: 'การจองกิจกรรม',
      user_attributes: 'คุณลักษณะผู้ใช้',
      shareholder: 'ผู้ถือหุ้นฮิกะชิกะวะ',
      repeater: 'ผู้เยี่ยมชมซ้ำ',
      repeater_only: 'ผู้เยี่ยมชมซ้ำเท่านั้น',
      stockholder_only: 'ผู้ถือหุ้นเท่านั้น',
      both: 'ทั้งผู้เยี่ยมชมซ้ำและผู้ถือหุ้น',
      other: 'อื่นๆ',
      total: 'รวม',
      peopleUnit: ' คน',
      booked_label: 'จองแล้ว',
      available_label: 'ว่าง',
      total_capacity: 'รวมจำนวนกิจกรรม: {count} คน',
      top_events: 'กิจกรรมอันดับต้น',
      table: {
        event_name: 'ชื่อกิจกรรม',
        capacity: 'ความจุ',
        online: 'ออนไลน์',
        organizer: 'ผู้จัดงาน',
        date: 'วันที่จัดงาน',
      },
      event_list_link: 'รายการกิจกรรมทั้งหมด',
      no_data: 'ไม่มีข้อมูล',
    },

    tooltips: {
      visitorCard: 'เราจะนับจำนวนผู้เยี่ยมชมที่ได้จองที่พักหรือกิจกรรมในช่วงเวลาที่เลือก',
      repeatVisitorCard: 'นี่คือเปอร์เซ็นต์ของผู้เยี่ยมชมซ้ำในช่วงเวลาที่เลือก อัตราการเปลี่ยนแปลงแสดงถึงการเปรียบเทียบกับช่วงเวลาเดียวกันของปีที่แล้ว เนื่องจากนับผู้มาเยือนแต่ละคนในช่วงเวลา จำนวนรวมอาจไม่ตรงกับกราฟแนวโน้มผู้มาเยือน',
      higashikawaStockholderVisitorCard: 'ข้อมูลนี้แสดงเปอร์เซ็นต์ของผู้เยี่ยมชมจากผู้ถือหุ้นฮิงาชิกาวะในช่วงเวลาที่เลือก อัตราการเปลี่ยนแปลงนี้แสดงถึงการเปรียบเทียบกับช่วงเวลาเดียวกันของปีที่แล้ว เนื่องจากนับผู้มาเยือนแต่ละคนในช่วงเวลา จำนวนรวมอาจไม่ตรงกับกราฟแนวโน้มผู้มาเยือน',
      ageGroupChartCard: 'รวบรวมผู้มาเยือนในช่วงเวลาที่เลือกตามกลุ่มอายุ (ไม่รวมคำตอบที่ไม่มี) เนื่องจากวิธีการรวบรวมแตกต่างกัน จำนวนรวมอาจไม่ตรงกับกราฟแนวโน้มผู้มาเยือน',
      genderChartCard: 'รวบรวมผู้มาเยือนในช่วงเวลาที่เลือกตามเพศ (ไม่รวมคำตอบที่ไม่มี) เนื่องจากวิธีการรวบรวมแตกต่างกัน จำนวนรวมอาจไม่ตรงกับกราฟแนวโน้มผู้มาเยือน',
      occupancyCard: 'แสดงอัตราส่วนของห้องที่จองผ่าน tomarin ต่อจำนวนห้องทั้งหมด × จำนวนวันในช่วงเวลาที่เลือก',
      crowdLevelCalendarCard: 'ปฏิทินแสดงสีตามจำนวนผู้เข้าร่วมกิจกรรมในเดือนที่วันที่เริ่มต้นของช่วงเวลาที่เลือกอยู่ โปรดทราบว่ากิจกรรมออนไลน์จะไม่แสดงบนปฏิทิน',
      topEvents: 'กิจกรรม 5 อันดับแรกที่มีความจุสูงสุดจะแสดงอยู่ในกิจกรรมที่กำหนดไว้สำหรับช่วงเวลาที่เลือกในปฏิทิน',
    },

    // Repeat Visitor Detail Modal
    repeatVisitorDetail: {
      selectedPeriod: 'ช่วงเวลาที่เลือก',
      previousYearPeriod: 'ช่วงเวลาปีที่แล้ว',
      changeRate: 'อัตราการเปลี่ยนแปลง',
      repeatVisitors: 'ผู้มาเยือนซ้ำ: ',
      total: 'ทั้งหมด: ',
      personUnit: ' คน',
      additionalNote: '* เนื่องจากนับผู้มาเยือนแต่ละคนในช่วงเวลา จำนวนรวมอาจไม่ตรงกับกราฟแนวโน้มผู้มาเยือน',
    },

    // Higashikawa Stockholder Visitor Detail Modal
    higashikawaStockholderVisitorDetail: {
      selectedPeriod: 'ช่วงเวลาที่เลือก',
      previousYearPeriod: 'ช่วงเวลาปีที่แล้ว',
      changeRate: 'อัตราการเปลี่ยนแปลง',
      higashikawaStockholderVisitors: 'ผู้ถือหุ้น: ',
      total: 'ทั้งหมด: ',
      personUnit: ' คน',
      additionalNote: '* เนื่องจากนับผู้มาเยือนแต่ละคนในช่วงเวลา จำนวนรวมอาจไม่ตรงกับกราฟแนวโน้มผู้มาเยือน',
    },

    // Age Group Visitor Detail Modal
    ageGroupVisitorDetail: {
      additionalNote: '* เนื่องจากนับผู้มาเยือนแต่ละคนในช่วงเวลา จำนวนรวมอาจไม่ตรงกับกราฟแนวโน้มผู้มาเยือน',
      peopleUnit: ' คน',
    },

    // Gender Visitor Detail Modal
    genderVisitorDetail: {
      additionalNote: '* เนื่องจากนับผู้มาเยือนแต่ละคนในช่วงเวลา จำนวนรวมอาจไม่ตรงกับกราฟแนวโน้มผู้มาเยือน',
      peopleUnit: ' คน',
    },
  },

  // Master Data
  guestDemographics: {
    age_less_20: '〜20',
    age_20: '20〜30',
    age_30: '30〜40',
    age_40: '40〜50',
    age_50: '50〜60',
    age_more_60: '60〜',
    age_other: 'อื่นๆ',
    male: 'ชาย',
    female: 'หญิง',
    no_answer: 'ไม่ระบุ',
  },
  eventDetail: {
    edit: 'แก้ไข',
    eventDate: 'วันที่จัดงาน',
    fee: 'ค่าเข้าร่วม',
    capacity: 'จำนวนที่รับ',
    peopleUnit: ' คน',
    currencyUnit: ' เยน',
    dateFormat: '{day}/{month}/{year}',
    bookingRate: 'จำนวนการจอง',
    accommodationGuests: 'ผู้เข้าพักในเมือง',
    repeaters: 'ผู้มาเยือนซ้ำ',
    stockholders: 'ผู้ถือหุ้นฮิงาชิกาวะ',
    ageGroups: 'ช่วงอายุ',
    genders: 'เพศ',
    genderNoAnswer: 'ไม่ระบุ',
    residentialAreas: 'พื้นที่พำนัก',
    distributionComparison: 'เปรียบเทียบการกระจาย',
    participants: 'ผู้เข้าร่วม',
    allEvents: 'อีเวนต์ทั้งหมด',
    showMore: 'ดูเพิ่มเติม',
    showLess: 'ย่อ',
    noData: 'ไม่มีข้อมูล',
    loading: 'กำลังโหลด...',
    notFound: 'ไม่พบอีเวนต์',
  },
  accommodationSummary: {
    title: 'ที่พัก',
    bookings: 'จำนวนการจอง',
    bookingsSubtitle: 'แนวโน้มการจองผ่าน tomarin',
    help: 'แสดงข้อมูลการจองที่พักในช่วงเวลาที่เลือก ตามการรวบรวมข้อมูลรายวันล่าสุด',
    resetView: 'รีเซ็ตการแสดงผล',
    peopleUnit: ' คน',
    selectedPeriod: 'ช่วงเวลาที่เลือก',
    previousYearPeriod: 'ช่วงเดียวกันปีก่อน',
    occupancy: 'อัตราการเข้าพัก',
    repeaters: 'ผู้เข้าพักซ้ำ',
    stockholders: 'ผู้ถือหุ้นฮิงาชิกาวะ',
    ageGroups: 'ช่วงอายุ',
    genders: 'เพศ',
    genderNoAnswer: 'ไม่ระบุ',
    residentialAreas: 'พื้นที่พำนัก',
    noData: 'ไม่มีข้อมูล',
  },
  collectedEvents: {
    tabSources: 'แหล่งที่มา',
    sourceUrl: 'URL',
    sourceMethod: 'วิธีดึงข้อมูล',
    sourceTotal: 'รวมที่รวบรวม',
    sourceLastRun: 'รวบรวมล่าสุด',
    sourceNeverRun: 'ยังไม่เคยรัน',
    sourceOk: 'สำเร็จ',
    sourceFailed: 'ล้มเหลว',
    category: 'หมวดหมู่',
    collectNow: 'รวบรวมตอนนี้',
    collectErrors: 'แหล่งที่ล้มเหลว',
    collectFailed: 'การรวบรวมล้มเหลว',
    title: 'อีเวนต์ที่รวบรวม',
    description: 'รายการอีเวนต์ที่รวบรวมอัตโนมัติทุกเช้าจากเว็บไซต์ในเมือง กรุณาตรวจสอบแล้วลงทะเบียนหรือทำเครื่องหมายว่าไม่เกี่ยวข้อง อีเวนต์ที่ลงทะเบียนจะถูกสร้างเป็นฉบับร่าง',
    source: 'แหล่งที่มา',
    eventTitle: 'ชื่ออีเวนต์',
    period: 'วันที่จัด',
    venue: 'สถานที่',
    actions: 'การดำเนินการ',
    approve: 'ลงทะเบียน',
    reject: 'ไม่เกี่ยวข้อง',
    approveTitle: 'ลงทะเบียนเป็นอีเวนต์',
    approveNote: 'เนื้อหาที่รวบรวมมาจากการสกัดอัตโนมัติและอาจมีข้อผิดพลาด กรุณาตรวจสอบและแก้ไขก่อนลงทะเบียน',
    approveSubmit: 'ลงทะเบียน',
    approveFailed: 'การลงทะเบียนล้มเหลว',
    cancel: 'ยกเลิก',
    startDate: 'วันเริ่ม',
    endDate: 'วันสิ้นสุด',
    capacity: 'จำนวนที่รับ',
    feeAmount: 'ค่าเข้าร่วม (เยน)',
    feeSource: 'ตามที่รวบรวมได้',
    descriptionLabel: 'คำอธิบาย',
    statusPending: 'รอตรวจสอบ',
    statusApproved: 'ลงทะเบียนแล้ว',
    statusRejected: 'ไม่เกี่ยวข้อง',
    loading: 'กำลังโหลด...',
    empty: 'ไม่พบอีเวนต์',
  },
  adminDashboard: {
    pendingRequests: 'คำขอลงทะเบียนผู้ใช้ที่รอการอนุมัติ',
    errors24h: 'ข้อผิดพลาดใน 24 ชั่วโมงที่ผ่านมา',
    countUnit: 'รายการ',
    errorsBreakdown: 'API สาธารณะ: {api} / การดำเนินการ: {operation}',
    providersTitle: 'สถานะการรับข้อมูลจากผู้ให้บริการข้อมูล',
    providerName: 'ชื่อผู้ให้บริการ',
    lastCalledAt: 'รับข้อมูลล่าสุด',
    calls24h: 'การเรียกใช้ (24 ชม.)',
    providerErrors24h: 'ข้อผิดพลาด (24 ชม.)',
    neverCalled: 'ยังไม่เคยรับข้อมูล',
    noProviders: 'ไม่พบผู้ให้บริการข้อมูล',
    tablesTitle: 'จำนวนข้อมูลหลัก',
    loading: 'กำลังโหลด...',
  },
  masterData: {
    title: 'รายการข้อมูลหลัก',
    detailTitle: 'รายละเอียดข้อมูลหลัก',
    tableNameHeader: 'ชื่อตาราง',
    rowCountHeader: 'จำนวนแถว',
    lastUpdatedHeader: 'อัปเดตล่าสุด',
    loading: 'กำลังโหลด...',
    noTablesFound: 'ไม่พบตาราง',
    filters: {
      createdDate: 'วันที่สร้าง',
      updatedDate: 'วันที่อัปเดต',
      searchButton: 'ค้นหา',
      filterStart: 'จุดเริ่มต้นการกรอง',
      filterEnd: 'จุดสิ้นสุดการกรอง',
      toggleIncludeDeleted: 'รวมที่ถูกลบ'
    },
  },

  // Accommodation Bookings
  accommodationBookings: {
    title: 'รายการจองที่พัก',
    loading: 'กำลังโหลด...',
    noBookingsFound: 'ไม่พบการจองที่พัก',
    filters: {
      checkinDate: 'เช็คอิน',
      checkoutDate: 'เช็คเอาท์',
      status: 'สถานะ',
      allStatus: 'สถานะทั้งหมด',
      searchButton: 'ค้นหา',
      filterStart: 'วันที่เริ่มต้น',
      filterEnd: 'วันที่สิ้นสุด'
    },
    status: {
      confirmed: 'ยืนยันแล้ว',
      cancelled: 'ยกเลิก',
      pending: 'รอดำเนินการ'
    },
    table: {
      id: 'ID',
      hotelName: 'ชื่อสถานที่พัก',
      checkinDate: 'เช็คอิน',
      checkoutDate: 'เช็คเอาท์',
      guestCount: 'จำนวนผู้เข้าพัก',
      hasMeal: 'มีอาหาร',
      hasEventGuests: 'มี/ไม่มีการจองกิจกรรม',
      totalPrice: 'ราคารวม',
      status: 'สถานะ',
      createdAt: 'วันเวลาที่สร้าง'
    },
    csvExport: {
      button: 'ส่งออก CSV',
      title: 'ส่งออก CSV',
      message: 'ส่งออกผลการค้นหา {count} รายการเป็น CSV',
      encodingLabel: 'การเข้ารหัส',
      cancel: 'ยกเลิก',
      export: 'ส่งออก',
      exporting: 'กำลังส่งออก...'
    }
  },

  // Postal Codes
  postalCodes: {
    title: 'รหัสไปรษณีย์มาสเตอร์',
    csvImport: 'นำเข้า CSV',
    importing: 'กำลังนำเข้า...',
    importComplete: 'นำเข้าเสร็จสิ้น',
    importCount: 'จำนวนที่นำเข้า: {count} รายการ',
    errors: 'ข้อผิดพลาด:',
    moreErrors: '...และอีก {count} รายการ',
    table: {
      postalCode: 'รหัสไปรษณีย์',
      prefecture: 'จังหวัด',
      city: 'เมือง/เขต',
      area: 'พื้นที่',
      prefectureKana: 'จังหวัด（คานะ）',
      cityKana: 'เมือง/เขต（คานะ）',
      areaKana: 'พื้นที่（คานะ）'
    },
    importModal: {
      title: 'นำเข้าไฟล์ CSV',
      fileLabel: 'กรุณาเลือกไฟล์ CSV',
      fileHelp: 'กรุณาอัปโหลดไฟล์ ken_all.csv ของ Japan Post（เข้ารหัส Shift-JIS）',
      cancel: 'ยกเลิก',
      import: 'นำเข้า'
    }
  },

  // Import
  import: {
    ledghome: {
      title: 'นนำเข้า > ข้อมูลผู้บริจาค',
      description: 'คุณสามารถนำเข้าไฟล์ CSV "寄附者情報" ที่ส่งออกมาจาก LedgHome',
      dropMessage: 'คลิกที่นี่เพื่อเลือกไฟล์หรือ\nลากและวางไฟล์',
      importButton: 'นำเข้า',
      importing: 'กำลังนำเข้า...',
      maxFilesError: 'คุณสามารถอัปโหลดได้สูงสุด {max} ไฟล์',
      importError: 'การนำเข้าล้มเหลว',
      results: {
        title: 'ผลการนำเข้า',
        titleSuccess: 'การนำเข้าเสร็จสมบูรณ์',
        titleWithErrors: 'การนำเข้าเสร็จสมบูรณ์ (มีข้อผิดพลาด)',
        totalFiles: 'จำนวนไฟล์ทั้งหมด',
        processedFiles: 'ไฟล์ที่ประมวลผล',
        totalRows: 'จำนวนแถวทั้งหมด',
        createdDonators: 'ผู้บริจาคที่สร้างใหม่',
        updatedDonators: 'ผู้บริจาคที่อัปเดต',
        createdStockholders: 'ผู้ถือหุ้นที่สร้างใหม่',
        updatedStockholders: 'ผู้ถือหุ้นที่อัปเดต',
        deletedStockholders: 'ผู้ถือหุ้นที่ลบ',
        errors: 'ข้อผิดพลาด'
      }
    },
    messages: {
      data_provider_not_found: 'ไม่พบผู้ให้บริการข้อมูล',
      import_completed: 'การนำเข้าเสร็จสมบูรณ์',
      import_failed: 'การนำเข้าล้มเหลว',
      donator_number_required: 'จำเป็นต้องระบุหมายเลขผู้บริจาค'
    },
    validation: {
      files_required: 'กรุณาเลือกไฟล์',
      files_array: 'ไฟล์ต้องเป็นอาร์เรย์',
      files_max: 'คุณสามารถอัปโหลดได้สูงสุด 10 ไฟล์',
      file_required: 'จำเป็นต้องมีไฟล์',
      file_type: 'ประเภทไฟล์ไม่ถูกต้อง',
      file_mimes: 'สามารถอัปโหลดได้เฉพาะไฟล์ CSV (.csv, .txt)',
      file_size_max: 'ขนาดไฟล์ต้องน้อยกว่า 50MB'
    }
  },

  // Events
  events: {
    titleList: 'รายการกิจกรรม',
    helpTooltip: 'แสดงกิจกรรมที่กำหนดไว้สำหรับช่วงเวลาที่เลือก',
    eventName: 'ชื่อกิจกรรม',
    capacity: 'ความจุ',
    isOnline: 'ออนไลน์',
    organizer: 'ผู้จัด',
    eventDate: 'วันที่',
    fee: 'ค่าธรรมเนียม',
    noData: 'ไม่มีข้อมูล',
    loading: 'กำลังโหลด...',
    additionalOrganizers: '+{count} อื่นๆ',
  },

  // Event Organizers
  eventOrganizers: {
    title: 'ผู้จัดงาน',
    titleList: 'ข้อมูลหลัก',
    edit: 'แก้ไข',
    create: 'สร้าง',
    search: 'ค้นหา',
    searchPlaceholder: 'ค้นหาตามชื่อผู้จัดงาน...',
    addNew: 'เพิ่มใหม่',
    organizer: 'ผู้จัดงาน',
    organizerName: 'ชื่อผู้จัดงาน',
    phoneMain: 'เบอร์โทรศัพท์ (หลัก)',
    phoneSub: 'เบอร์โทรศัพท์ (รอง)',
    emailMain: 'อีเมล (หลัก)',
    emailSub: 'อีเมล (รอง)',
    address: 'ที่อยู่',
    postalCode: 'รหัสไปรษณีย์',
    postalCodePlaceholder: '888-8888',
    prefecture: 'จังหวัด',
    prefectureDefault: 'กรุณาเลือก',
    city: 'เมือง',
    cityPlaceholder: 'คามิกาวะ-กุน ฮิกาชิกาวะ-โช',
    cityDetail: 'รายละเอียดที่อยู่',
    cityDetailPlaceholder: '1-1-1',
    building: 'อาคาร',
    buildingPlaceholder: 'Sentopure',
    delete: 'ลบ',
    cancel: 'ยกเลิก',
    update: 'อัปเดต',
    noData: 'ไม่มีข้อมูล',
    loading: 'กำลังโหลด...',
    required: 'จำเป็น',
    confirmDelete: 'คุณแน่ใจหรือไม่ที่จะลบ? การดำเนินการนี้ไม่สามารถยกเลิกได้',
    errorFetchData: 'การดึงข้อมูลล้มเหลว',
    successUpdate: 'อัปเดตผู้จัดงานสำเร็จ',
    successCreate: 'สร้างผู้จัดงานสำเร็จ',
    errorSave: 'การบันทึกล้มเหลว',
    successDelete: 'ลบผู้จัดงานสำเร็จ',
    errorDelete: 'การลบล้มเหลว',
    errorDeleteInUse: 'ผู้จัดงานนี้ถูกใช้ในงานอยู่แล้วและไม่สามารถลบได้ กรุณาลบผู้จัดงานออกจากงานก่อน',
    validation: {
      nameRequired: 'กรุณาใส่ชื่อผู้จัดงาน',
      nameMaxLength: 'ชื่อผู้จัดงานต้องมีความยาวไม่เกิน 255 ตัวอักษร',
      phoneInvalid: 'เบอร์โทรศัพท์ต้องเป็นตัวเลขและเครื่องหมายขีด (-) เท่านั้น',
      phoneMaxLength: 'เบอร์โทรศัพท์ต้องมีความยาวไม่เกิน 20 ตัวอักษร',
      emailInvalid: 'กรุณาใส่อีเมลที่ถูกต้อง',
      emailMaxLength: 'อีเมลต้องมีความยาวไม่เกิน 255 ตัวอักษร',
      postalCodeRequired: 'กรุณาใส่รหัสไปรษณีย์',
      postalCodeInvalid: 'รหัสไปรษณีย์ต้องอยู่ในรูปแบบ 999-9999',
      postalCodeMaxLength: 'รหัสไปรษณีย์ต้องมีความยาวไม่เกิน 10 ตัวอักษร',
      prefectureRequired: 'กรุณาเลือกจังหวัด',
      cityRequired: 'กรุณาใส่เมือง',
      cityMaxLength: 'เมืองต้องมีความยาวไม่เกิน 100 ตัวอักษร',
      townMaxLength: 'รายละเอียดที่อยู่ต้องมีความยาวไม่เกิน 100 ตัวอักษร',
      buildingMaxLength: 'ชื่ออาคารต้องมีความยาวไม่เกิน 200 ตัวอักษร'
    },
    messages: {
      fetchFailed: 'การดึงข้อมูลล้มเหลว',
      updated: 'อัปเดตผู้จัดงานสำเร็จ',
      created: 'สร้างผู้จัดงานสำเร็จ',
      saveFailed: 'การบันทึกล้มเหลว',
      deleted: 'ลบผู้จัดงานสำเร็จ',
      deleteFailed: 'การลบล้มเหลว'
    }
  },

  // Master Events
  masterEvents: {
    title: 'กิจกรรม',
    titleList: 'ข้อมูลหลัก',
    searchPlaceholder: 'ค้นหาตามชื่อกิจกรรม...',
    addNew: 'เพิ่มใหม่',
    eventName: 'ชื่อกิจกรรม',
    description: 'คำอธิบาย',
    startDate: 'วันที่เริ่มต้น',
    endDate: 'วันที่สิ้นสุด',
    capacity: 'ความจุ',
    forecastedVisitorCount: 'จำนวนผู้เยี่ยมชมที่คาดการณ์',
    isOnline: 'ออนไลน์',
    organizer: 'ผู้จัดงาน',
    feeMax: 'ค่าใช้จ่าย (สูงสุด)',
    feeMin: 'ค่าใช้จ่าย (ต่ำสุด)',
    noData: 'ไม่มีข้อมูล',
    loading: 'กำลังโหลด...',
    edit: 'แก้ไข',
    create: 'สร้าง',
    createButton: 'สร้าง',
    update: 'อัปเดต',
    cancel: 'ยกเลิก',
    delete: 'ลบ',
    organizers: 'ผู้จัดงาน',
    fees: 'ค่าธรรมเนียม',
    selectOrganizer: 'เลือกผู้จัดงาน',
    isPrimary: 'หลัก',
    addOrganizer: 'เพิ่มผู้จัดงาน',
    feeType: 'ประเภทค่าธรรมเนียม',
    feeAmount: 'จำนวนเงิน',
    feeDescription: 'คำอธิบาย',
    addFee: 'เพิ่มค่าธรรมเนียม',
    confirmDelete: 'คุณแน่ใจหรือไม่ว่าต้องการลบกิจกรรมนี้?',
    successUpdate: 'อัปเดตกิจกรรมสำเร็จ',
    successCreate: 'สร้างกิจกรรมสำเร็จ',
    successDelete: 'ลบกิจกรรมสำเร็จ',
    errorFetchData: 'ไม่สามารถดึงข้อมูลได้',
    errorSave: 'ไม่สามารถบันทึกได้',
    errorDelete: 'ไม่สามารถลบได้',
    errorDeleteInUse: 'ไม่สามารถลบกิจกรรมนี้ได้เนื่องจากมีข้อมูลการจองที่เชื่อมโยงอยู่',
    // Image upload section
    addImage: 'เพิ่มรูปภาพ',
    imageCountHint: 'สูงสุด 5 รูป',
    analyzing: 'กำลังวิเคราะห์ด้วย AI...',
    analyzeWithAI: 'วิเคราะห์ด้วย AI',
    // Event form
    eventNumber: 'กิจกรรม {n}',
    organizerTooltip: 'เลือกผู้จัดงานที่ลงทะเบียนในข้อมูลหลักผู้จัดงาน',
    searchOrganizer: 'ค้นหาผู้จัดงาน...',
    dateRange: 'ระยะเวลากิจกรรม',
    currencyYen: '¥{amount}',
    capacityWithHint: 'ความจุ',
    capacityUnit: 'คน',
    forecastedVisitorCount: 'จำนวนผู้เยี่ยมชมที่คาดการณ์',
    onlineEvent: 'กิจกรรมออนไลน์',
    deleteEvent: 'ลบกิจกรรม',
    addEventInput: 'เพิ่มฟอร์มกิจกรรม',
    participationFee: 'ค่าเข้าร่วม',
    // Messages
    analyzeSuccess: 'วิเคราะห์ใบปลิวกิจกรรมเสร็จสมบูรณ์',
    successCreateBulk: 'สร้างกิจกรรม {count} รายการแล้ว',
    errorNoFilesToAnalyze: 'ไม่มีรูปภาพที่จะวิเคราะห์',
    errorAnalyze: 'ไม่สามารถวิเคราะห์ใบปลิวกิจกรรมได้',
    validation: {
      titleRequired: 'กรุณากรอกชื่อกิจกรรม',
      titleMaxLength: 'ชื่อกิจกรรมต้องมีความยาวไม่เกิน 255 ตัวอักษร',
      startDateRequired: 'กรุณากรอกวันที่เริ่มต้น',
      endDateRequired: 'กรุณากรอกวันที่สิ้นสุด',
      endDateAfterStart: 'วันที่สิ้นสุดต้องอยู่หลังวันที่เริ่มต้น',
      organizerRequired: 'กรุณาเพิ่มผู้จัดงานอย่างน้อย 1 คน',
      organizerSelectRequired: 'กรุณาเลือกผู้จัดงาน',
      feeTypeRequired: 'กรุณากรอกประเภทค่าธรรมเนียม',
      feeAmountRequired: 'กรุณากรอกจำนวนเงิน',
      organizerDuplicate: 'เลือกผู้จัดงานซ้ำกัน',
      feeTypeDuplicate: 'ตั้งชื่อประเภทค่าธรรมเนียมซ้ำกัน',
      forecastedVisitorCountRequired: 'จำเป็นต้องกรอกจำนวนผู้เยี่ยมชมที่คาดการณ์เมื่อไม่ได้กรอกความจุ'
    }
  },

  // Export
  export: {
    statisticData: {
      title: 'ส่งออก > สถิติ',
      description: 'คุณสามารถส่งออกข้อมูลสถิติต่างๆ ที่สร้างโดยบริการนี้',
      periodLabel: 'ช่วงเวลารวมข้อมูล',
      dataTypeLabel: 'ประเภทข้อมูล',
      dataTypes: {
        statistic_summaries: 'สถิติรวม',
        statistic_visitor_attributes: 'คุณลักษณะผู้เยี่ยมชม',
        statistic_visitor_accommodation_bookings: 'สถิติที่พัก',
        statistic_visitor_event_bookings: 'สถิติกิจกรรม'
      },
      encodingLabel: 'รูปแบบข้อมูลส่งออก',
      encodings: {
        sjis: 'Shift-JIS',
        utf8: 'UTF-8'
      },
      exportButton: 'ส่งออก',
      exporting: 'กำลังส่งออก...',
      errors: {
        select_data_type: 'กรุณาเลือกประเภทข้อมูล',
        select_encoding: 'กรุณาเลือกรูปแบบข้อมูลส่งออก',
        max_days: 'กรุณาระบุช่วงเวลาภายใน 100 วัน',
        invalid_date_range: 'วันที่สิ้นสุดต้องอยู่หลังจากวันที่เริ่มต้น',
        no_permission: 'คุณไม่มีสิทธิ์ดำเนินการ CSV',
        export_failed: 'การส่งออก CSV ล้มเหลว',
        invalid_data: 'ข้อมูลที่ป้อนไม่ถูกต้อง'
      },
      warnings: {
        not_implemented: 'ไม่สามารถส่งออกได้เนื่องจากอยู่ระหว่างการพัฒนา',
      },
      tooltips: {
        dateRange: 'ใช้เพื่อกรองตามวันที่อ้างอิงของสถิติที่สร้างขึ้นทุกวัน คุณสามารถเลือกได้สูงสุด 100 วันภายในช่วงของข้อมูลสถิติที่สร้างขึ้น',
        encodingType: 'ตามกฎทั่วไป ผู้ใช้ Windows ควรใช้ Shift-JIS และผู้ใช้ MacOS ควรใช้ UTF-8 หากตัวอักษรปรากฏเป็นสัญลักษณ์ผิดเพี้ยน กรุณาตรวจสอบการตั้งค่าการเข้ารหัสของแอปพลิเคชันที่คุณใช้งานในสภาพแวดล้อมของคุณ',
      }
    }
  }
};
